// /**
//  * Center - Add
//  */

// React
import React, {useState, useEffect} from 'react';

// UI
import {Grid, CardContent, Card, Typography} from '@material-ui/core';

// Type
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import ContactsRepository from 'client-sdk/src/Repository/contacts-repository';
import handleError from './../../utils/handleError';
import RonadIcons from '../../components/iconComponent';
import ConfirmModal from '../../components/Modal/confirm';
import {Link} from 'react-router-dom';
import disableElement from '../../utils/disableElement';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      marginBottom: '24px',
      overflow: 'visible',
      paddingBottom: '0',
    },
    cardContentOrder: {
      maxHeight: '600px',
      overflow: 'scroll',
    },
    addContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px',
      backgroundColor: '#3449B033',
      borderRadius: '4px',
    },
  })
);

const profile = localStorage.getItem('profile') || []

function Contacts() {
  const classes = useStyles();
  const [contacts, setContacts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [dialog, setDialog] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getContacts();
  }, []);

  const getContacts = async () => {
    try {
      const response = await ContactsRepository.getContacts({payload: {sort: "fullName,asc",size: 1000}});
      setContacts(response.data);
    } catch (err) {
      handleError(err);
    }
  };

  const clickOnDelete = (id: string) => {
    setSelected(id);
    setDialog('DELETE');
  };

  const deleteContact = async () => {
    try {
      await ContactsRepository.deleteContact({
        payload: {
          id: selected,
        },
      });
      getContacts();
      setDialog("");
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="page-root">
      <p className="typography-cards">اطلاعات مخاطبین</p>
      <Card className={classes.card}>
        <CardContent className={classes.cardContentOrder}>
          {contacts.length > 0 ? contacts.map((el: any, index: number) => (
            <Grid container className="card mb-3">
              <Grid item xs={10}>
                <p className="font-bold" style={{fontSize: '18px'}}>
                  {el?.fullName}
                </p>
                <div
                  className="mt-2 mb-2"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '16px',
                  }}
                >
                  <p>کدملی: {el?.nationalCode}</p>
                  <p>کدپستی: {el?.postalCode}</p>
                  <p>شماره همراه: {el?.mobile}</p>
                </div>
                <p
                  style={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    fontSize: '16px',
                  }}
                >
                  {el?.address}
                </p>
              </Grid>
              <Grid
                container
                item
                alignItems="center"
                justifyContent="flex-end"
                xs={2}
              >
                <Link to={`contacts/edit?mobile=${el?.mobile}`}>
                  <RonadIcons
                    name="edit"
                    title="ویرایش"
                    className="ml-2"
                    style={{color: '#3449B0'}}
                  />
                </Link>
                <RonadIcons
                  name="trash"
                  title="حذف"
                  className="text-danger ml-3"
                  onClick={() => clickOnDelete(el.id)}
                />
              </Grid>
            </Grid>
          )) : <Typography variant='h4' align='center'>مخاطبی وجود ندارد</Typography>}
        </CardContent>
      </Card>
      <div className={classes.addContainer}>
        <p className="font-bold">مخاطب جدید</p>
        {disableElement(profile) ? 
        <RonadIcons
          name="plus"
          title="افزودن مخاطب"
          style={{color: '#f3f3f3'}}
        />
       : <Link to={`/contacts/add`}>
          <RonadIcons
            name="plus"
            title="افزودن مخاطب"
            style={{color: '#217AFF'}}
          />
        </Link>}
      </div>
      <ConfirmModal
        open={dialog === 'DELETE'}
        onClose={() => setDialog('')}
        onSubmit={deleteContact}
        loading={loading}
      >
        <Typography variant={'h6'}>
          {`آیا از حذف مخاطب مطمئن هستید؟`}
        </Typography>
      </ConfirmModal>
    </div>
  );
}

export default Contacts;
